import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useLocation, useParams } from 'react-router';
import styled from 'styled-components';
import { COLORS } from '@fupa/fupa-uikit';
import { fetchMediaList } from 'app/queries/districtMedia';
import MediaModuleHeader from 'app/components/mediaModule/header/MediaModuleHeader';
import MediaModuleContent from 'app/components/mediaModule/content/MediaModuleContent';
import MediaModuleError from 'app/components/mediaModule/MediaModuleError';
import LoadingSkeleton from 'app/components/mediaModule/content/LoadingSkeleton';
import FuPaApiError from 'app/models/error/FuPaApiError';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1plu4pt-0"
})(["display:flex;flex-direction:column;width:100%;background-color:", ";"], COLORS.white);
export default function MediaModule(_ref) {
  let {
    initialData,
    districtName
  } = _ref;
  const {
    districtSlug
  } = useParams();
  const location = useLocation();
  const {
    data,
    isError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: ['media', {
      districtSlug
    }],
    queryFn: () => fetchMediaList(districtSlug),
    initialData: initialData,
    onError: error => error // only used for typing purposes
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(MediaModuleHeader, {
      pathname: location.pathname
    }), /*#__PURE__*/React.createElement(LoadingSkeleton, null));
  }
  if (isError || !data) {
    return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(MediaModuleHeader, null), /*#__PURE__*/React.createElement(MediaModuleError, {
      onRetry: refetch
    }));
  }
  if (data instanceof FuPaApiError) {
    return /*#__PURE__*/React.createElement(Wrapper, {
      id: data.getHttpStatusId()
    }, /*#__PURE__*/React.createElement(MediaModuleHeader, null), /*#__PURE__*/React.createElement(MediaModuleError, {
      onRetry: refetch
    }));
  }
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "MediaModule",
    "data-sentry-source-file": "MediaModule.tsx"
  }, /*#__PURE__*/React.createElement(MediaModuleHeader, {
    pathname: location.pathname,
    "data-sentry-element": "MediaModuleHeader",
    "data-sentry-source-file": "MediaModule.tsx"
  }), /*#__PURE__*/React.createElement(MediaModuleContent, {
    data: data,
    districtName: districtName,
    "data-sentry-element": "MediaModuleContent",
    "data-sentry-source-file": "MediaModule.tsx"
  }));
}